module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    ref: "dialog",
    staticStyle: {
      "min-width": "1200px"
    },
    attrs: {
      "title": "",
      "size": "large",
      "before-close": _vm.handleClose
    },
    on: {
      "close": _vm.closeDialog
    }
  }, [(_vm.show) ? _c('form-render', {
    attrs: {
      "contentId": _vm.source.contentId,
      "dealId": _vm.source.dealId,
      "dataId": _vm.source.dataId,
      "ids": _vm.source.ids,
      "isDialog": true
    },
    on: {
      "saveCallback": _vm.saveCallback,
      "closeDialog": _vm.closeDialog
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-775d8610!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Content/instance/deal/editDeal.vue
// module id = 1930
// module chunks = 2